import Bugsnag from '@bugsnag/js';
import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { handleQuery } from '@99designs/graph-utils';
import { InspirationDocument, InspirationQuery } from '../graphql/InspirationDesigns.generated';
import type { Design } from '../types';

type DiscoverDesigns = { designs: Design[]; totalPages: number };

export async function getDesignInspirationByCategory(
    client: ApolloClient<NormalizedCacheObject>,
    category: string,
    searchTags?: string[],
    page?: number,
    pageSize?: number
): Promise<DiscoverDesigns> {
    const inputQuery = {
        categories: [category],
        pageSize: pageSize || 12,
        page: page || 1,
        tags: searchTags || [],
    };

    const { data, error } = await handleQuery<InspirationQuery>(client, {
        query: InspirationDocument,
        variables: {
            input: inputQuery,
        },
    });

    if (error) {
        Bugsnag.notify(new Error('Feature Design Inspiration - fetch error'), (event) => {
            event.context = `fetch error for ${JSON.stringify(inputQuery)}`;
        });
        return { designs: [], totalPages: 0 };
    }

    if (!data || !data.discoverDesigns || !data.discoverDesigns.designs) {
        Bugsnag.notify(new Error('Feature Design Inspiration - designs not found'), (event) => {
            event.context = `designs not found for ${JSON.stringify(inputQuery)}`;
        });
        return { designs: [], totalPages: 0 };
    }

    return data.discoverDesigns;
}
